import { useBillingStore } from '@/stores/BillingStore'
import { useUserStore } from '@/stores/UserStore'
import { useConnectionStore } from '@/stores/ConnectionStore'
import { FEATURE_MIN_PLAN } from '@/constants/plans'
import { isNewPlansEnabled } from '@/helpers/featureFlags'

// Returns true if the given channel has reached its connection limit.
// CollX is gated by total slots; all other channels reserve 1 slot for CollX.
export const hasReachedConnectionLimit = (channel) => {
  const userStore = useUserStore()
  const connectionStore = useConnectionStore()

  if (!isNewPlansEnabled()) return true

  const entitlement = userStore.user?.entitlements?.find(e => e.name === 'connections')
  if (!entitlement) return false

  if (channel.key === 'collx') {
    return connectionStore.addedChannels.length >= entitlement.units
  }

  const nonCollxChannels = connectionStore.addedChannels.filter(c => c.name !== 'CollX')
  return nonCollxChannels.length >= entitlement.units - 1
}

export const getPlanForFeature = (featureKey) => {
  const billingStore = useBillingStore()

  const plans = billingStore.plansOptions || []
  const currentPlan = billingStore.currentPlan

  const planId = FEATURE_MIN_PLAN[featureKey]

  return plans.find(plan => plan.id >= planId)
}

const PLAN_TIERS = { prospect: 0, majors: 1, all_star: 2 }

const parseMinNumber = (val) => {
  if (!val && val !== 0) return 0
  if (typeof val === 'number') return val
  const match = String(val).match(/(\d[\d,]*)/)
  return match ? Number(match[1].replace(/,/g, '')) : 0
}

export const getBestValuePlan = () => {
  const userStore = useUserStore()
  const data = userStore.user?.data

  let tier = PLAN_TIERS.prospect

  if (!data) return 'prospect'

  const allMarketplaces = [
    ...new Set([
      ...(data.connections?.current_marketplaces || []),
      ...(data.connections?.interested_marketplaces || []),
    ])
  ]

  if (allMarketplaces.some(m => m.toLowerCase() === 'shopify')) {
    return 'all_star'
  }

  const totalCards = parseMinNumber(data.organization?.total_cards)

  if (totalCards >= 10000) {
    tier = Math.max(tier, PLAN_TIERS.all_star)
  } else if (totalCards >= 1000) { 
    tier = Math.max(tier, PLAN_TIERS.majors)
  }

  const teamSize = parseMinNumber(data.organization?.team_size)

  if (teamSize >= 5) {
    tier = Math.max(tier, PLAN_TIERS.all_star)
  } else if (teamSize >= 1) {
    tier = Math.max(tier, PLAN_TIERS.majors)
  }

  const connectionCount = allMarketplaces.length

  if (connectionCount >= 3) {
    tier = Math.max(tier, PLAN_TIERS.all_star)
  } else if (connectionCount >= 2) {
    tier = Math.max(tier, PLAN_TIERS.majors)
  }

  return Object.keys(PLAN_TIERS).find(key => PLAN_TIERS[key] === tier)
}